import { withCatalogLayout } from "@/elements-react/catalog-layout/withCatalogLayout";
import { useWhoWeServeCommon } from "@/pages-react/who-we-serve/WhoWeServeCommon.tsx";
import { LayoutStyleTypes } from "@/util-react/layout";

export const WhoWeServeMobile = withCatalogLayout((props: { content: string }) => {
  const { renderContent } = useWhoWeServeCommon(props.content);

  return <>{renderContent()}</>;
}, LayoutStyleTypes.TYPE_SM);
